import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { API } from '../../api/axios';
import './Success.css'; // Import the new CSS file

const Success = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('verifying'); // 'verifying', 'success', 'error'
  const [message, setMessage] = useState('Just a moment, we are verifying your payment...');
  const navigate = useNavigate();
  const token = localStorage.getItem('token');  

  useEffect(() => {
    const sessionId = searchParams.get('session_id');

    if (sessionId && token) {
      API.get('/payments/verify-session', { params: { session_id: sessionId } })
        .then(async (response) => {
          if (response.data.status === 'processing') {
            setStatus('processing');
            setMessage('Your payment is being processed. Please do not submit the payment again.');
          } else if (response.data.success) {
            setStatus('success');
            setMessage(response.data.subscriptionStatus
              ? 'Your subscription is now active. Welcome aboard!'
              : 'Your payment was successful.');
            
            setTimeout(() => {
              navigate('/');
              window.location.reload();
            }, 5000);
          } else {
            setStatus('error');
            setMessage(
              'There was a problem with your payment. Please contact our support team.'
            );
          }
        })
        .catch(() => {
          setStatus('error');
          setMessage('An unexpected error occurred. Please try again or contact support.');
        });
    } else {
      setStatus('error');
      setMessage('Invalid session or authentication. Please try again.');
    }
  }, [searchParams, token, navigate]);

  return (
    <div className='success-page__container'>
      <div className='success-page__card'>
        {status === 'verifying' && (
          <>
            <div className='success-page__loading-icon'></div>
            <h2 className='success-page__title'>Verifying Payment</h2>
          </>
        )}
        {status === 'success' && (
          <>
            <div className='success-page__success-icon'>&#10004;</div>
            <h2 className='success-page__title'>Payment Successful!</h2>
          </>
        )}
        {status === 'processing' && (
          <>
            <div className='success-page__loading-icon'></div>
            <h2 className='success-page__title'>Payment Processing</h2>
          </>
        )}
        {status === 'error' && (
          <>
            <div className='success-page__error-icon'>&#10008;</div>
            <h2 className='success-page__title'>Payment Failed</h2>
          </>
        )}
        <p className='success-page__message'>{message}</p>
        {status === 'success' && (
          <p className='success-page__redirect'>
            You will be redirected to the homepage shortly...
          </p>
        )}
      </div>
    </div>
  );
};

export default Success;
